import validate from '../../../services/reduxValidate.js'

export default function(data) {
  return validate(data, {
    'freelance.summary': {
      presence: { allowEmpty: false },
      length: {
        maximum: 1300,
        message: 'Vos attentes ne peut pas dépasser 1300 caractères.'
      }
    },
  })
}
